export default __webpack_public_path__ + "static/media/bw_photos_tikal-3.22856be8.jpg";